import Vue from 'vue'
import Zap from './app.vue'

new Vue({
  render: h => h(Zap)
}).$mount('#app')